// A full page load, for the moment the session changes underneath the app (the
// email-code sign-in sets cookies the auth provider only reads on boot) — the
// same reason WebSignInLinkPage reloads. Its own module so tests can stub it.
export function hardNavigate(path: string): void {
  window.location.assign(path);
}
